if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      if (this.variantIdInput) {
        this.variantIdInput.disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      const variantId = this.ensureVariantId();
      if (!variantId) {
        this.handleErrorMessage(window.variantStrings?.unavailable || 'Please choose a product option.');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.loadingSpinner?.classList.add('hidden');
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.loadingSpinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.set('id', variantId);
      if (!formData.has('quantity')) {
        formData.set('quantity', this.variantIdInput?.dataset.quantityMin || '1');
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.loadingSpinner?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;

      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form?.querySelector('[name=id]');
    }

    ensureVariantId() {
      const input = this.variantIdInput;
      if (!input) return '';

      if (input.value) {
        input.disabled = false;
        return input.value;
      }

      const selectedVariantScript =
        this.closest('product-info')?.querySelector('[data-selected-variant]') ||
        this.querySelector('[data-selected-variant]');

      if (!selectedVariantScript?.textContent?.trim()) return '';

      try {
        const selectedVariant = JSON.parse(selectedVariantScript.textContent);
        if (!selectedVariant?.id) return '';

        input.value = selectedVariant.id;
        input.dataset.quantityMin = selectedVariant.quantity_rule?.min || input.dataset.quantityMin || '1';
        input.disabled = false;
        return input.value;
      } catch (error) {
        console.error(error);
        return '';
      }
    }

    get loadingSpinner() {
      return this.querySelector('.loading-overlay__spinner');
    }
  });
}
